<template>
  <div>
    <v-progress-linear v-if="loading" indeterminate></v-progress-linear>
    <DriversTotals :from="from"
                   :to="to"
                   :key="from+to"
                   :driverId="0"/>
    <v-layout v-if="!$root.isMobile">
      <v-flex shrink class="pl-2">
        <v-switch dense v-model="showAllSwitch" @change="fetchData" inset label="Show all"/>
      </v-flex>
      <v-flex grow class="pt-3">
        <v-text-field dense outlined class="ml-2 mr-2"
                      prepend-inner-icon="mdi-magnify"
                      placeholder="Start typing to filter driver by name"
          v-model="search"/>
      </v-flex>
    </v-layout>
    <v-data-table
      v-if="!$root.isMobile"
      height="calc(100vh - 300px)"
      fixed-header
      dense
      :headers="headers"
      :items-per-page="-1"
      :hide-default-footer="true"
      :items="filteredItems"
      @click:row="onReportSubTypeChanged('/reports/drivers/' + $event.id)"
    >
      <template v-slot:item.totalMilesByOdometer="{ item }">{{item.totalMilesByOdometer}}{{$t('milesShort')}}</template>
      <template v-slot:item.totalRateByOdometer="{ item }">{{$root.moneyValue(item.totalRateByOdometer, 2)}}&nbsp;</template>
      <template v-slot:item.totalDriverDetention="{ item }">{{$root.moneyValue(item.totalDriverDetention, 0)}}</template>
      <template v-slot:item.totalToCompensate="{ item }">{{$root.moneyValue(item.totalToCompensate, 0)}}</template>
      <template v-slot:item.totalBonuses="{ item }">{{$root.moneyValue(item.totalBonuses, 0)}}</template>
      <template v-slot:item.totalDeductions="{ item }">{{$root.moneyValue(item.totalDeductions, 0)}}</template>
      <template v-slot:item.totalFine="{ item }">{{$root.moneyValue(item.totalFine, 0)}}</template>
      <template v-slot:item.totalAdvance="{ item }">{{$root.moneyValue(item.totalAdvance, 0)}}</template>
      <template v-slot:item.totalSalary="{ item }"><v-chip small color="success">{{$root.moneyValue(item.totalSalary, 0)}}</v-chip></template>
    </v-data-table>
  </div>
</template>

<script>
import reportsMixin from '../../mixins/reportsMixin.js';
import DriversTotals from './DriverTotals';
export default {
  name: 'DispatchersTotalsList',
  props: ['to', 'from'],
  mixins: [ reportsMixin ],
  components: {
    DriversTotals
  },
  data: function () {
    return {
      loading: false,
      showAllSwitch: false,
      items: {},
      totalsCounts: {},
      search: '',
      headers: [
        { text: 'Driver', value: 'driver' },
        { text: 'Trips', value: 'trips' },
        { text: 'Loads', value: 'loads' },
        { text: 'Miles Driven', value: 'totalMilesByOdometer' },
        { text: 'Rate By Miles', value: 'totalRateByOdometer' },
        { text: 'Detention', value: 'totalDriverDetention' },
        { text: 'Compensations', value: 'totalToCompensate' },
        { text: 'Bonuses', value: 'totalBonuses' },
        { text: 'Deductions', value: 'totalDeductions' },
        { text: 'Fine', value: 'totalFine' },
        { text: 'Advance', value: 'totalAdvance' },
        { text: 'Salary', value: 'totalSalary' }
      ]
    };
  },
  mounted () {
    this.fetchData();
  },
  computed: {
    filteredItems () {
      if (this.search.length === 0) {
        return Object.values(this.items);
      }
      return Object.values(this.items).filter((item) => {
        return item.driver.toLowerCase().match(this.search)
      });
    }
  },
  methods: {
    onReportSubTypeChanged (path) {
      this.$root.setLocalStorageItem('reportTypePath', path);
      this.$root.route(path);
    },
    async fetchData () {
      let i = 0;
      let drivers = [];
      // Calc totals only for a big screen
      if (this.$root.isMobile) return;
      if (!this.from || !this.to) return;
      this.loading = true;
      // Get total miles
      this.items = [];
      drivers = [];
      const usersResponse = await this.$root.loadUsersList(this.$store.getters.roleDriver, false, true, this.showAllSwitch ? 0 : 1);
      if (usersResponse.status === 'ok') {
        drivers = usersResponse.result.data;
      }
      for (i = 0; i < drivers.length; i++) {
        this.$set(this.items, drivers[i].id, {
          id: drivers[i].id,
          driver: drivers[i].firstName + ' ' + drivers[i].lastName
        });
      }
      // Calc totals only for a big screen
      if (!this.$root.isMobile) {
        for (i = 0; i < drivers.length; i++) {
          const response = await this.getDriversReportTotalData(this.from, this.to, drivers[i].id);
          if (response.status === 'ok') {
            this.$set(this.items, drivers[i].id, response.results);
          }
        }
      }
      this.loading = false;
    }
  }
};
</script>
